import apiClient from '@/services/axios'

export async function patch(bookingId) {

  var response = await apiClient.patch(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings/' + bookingId + '/reopen-request');

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to patch booking to reopen request.')
}
